import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './QueryInput.css';

/**
 * Component for inputting queries to the Agent
 * @param {Object} props - Component props
 * @param {Function} props.onSendQuestion - Function to send the question
 * @param {boolean} props.isLoading - Whether a request is in progress
 * @param {boolean} [props.canShare] - Whether share is enabled (Q&A exists)
 * @param {Function} [props.onShare] - Share button handler
 * @returns {JSX.Element} Query input component
 */
const QueryInput = ({ onSendQuestion, isLoading, canShare = false, onShare }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim() && !isLoading) {
      onSendQuestion(query.trim());
      setQuery('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form className="query-input" onSubmit={handleSubmit}>
      <div className="input-container">
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
          rows={3}
          className="query-textarea"
        />
        <div className="input-actions">
          <button
            type="button"
            className="share-button"
            disabled={!canShare || isLoading}
            onClick={onShare}
            aria-label={t('chat.shareTitle')}
            title={t('chat.shareTitle')}
          >
            <svg className="share-button-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 15V3" />
              <path d="M8 7l4-4 4 4" />
              <path d="M8 10H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2" />
            </svg>
          </button>
          <button
            type="submit"
            disabled={!query.trim() || isLoading}
            className="send-button"
          >
            {isLoading ? t('chat.sending') : t('chat.send')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default QueryInput;
